// transfers
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";

import WebbSpinner from "../webb/webb-spinner-sm";
import WebbSpinText from "../webb/webb-spintext";
import ListNoData from "../webb/list-nodata";

import DataTable from "react-data-table-component";

import { GetContactsList, GetContactsCount } from "../../services/srvc-contacts-realm";

const list = [
  {code: 'indx', name: 'Person', actv: true},
  {code: 'tmbx', name: 'Team', actv: true},
  {code: 'bznx', name: 'Business', actv: true}
]

const columns = [

  { 
    name: 'Name', selector: row => row['name'], width:'20%',
    cell: row => 
    <div className={``}>
      <span className="text-sm">{row.name}</span>
    </div>
  },
  { 
    name: 'Email', selector: row => row['emid'], width:'25%',
    cell: row => 
    <div className={``}>
      <span className="text-sm">{row.emid}</span>
    </div>
  },
  { 
    name: 'Mobile', selector: row => row['mmid'], width:'15%',
    cell: row => 
    <div className={``}>
      <span className="text-sm">{row.mmid}</span>
    </div>
  },
  { 
    name: 'Type', selector: row => row['form'], width:'15%',
    cell: row => 
    <div className={``}>
      <span className="text-sm">{list.find(item=>item.code === row.form).name}</span>
    </div>
  },
  { 
    name: 'Type', selector: row => row['actv'], width:'15%',
    cell: row => 
    <div className={``}>
      <span className="text-sm">{row.actv ? 'Active' : 'Inactive'}</span>
    </div>
  },
  { 
    name: 'View', selector: row => row['enid'], width:'10%',
    cell: row => 
    <div className={``}>
      <Link to={`/`}>View</Link>
    </div>
  }
];

const customStyles = {
  rows: {
    style: {
      backgroundColor: 'white',
    }
  },
  headCells: {
    style: {
      backgroundColor: 'white',
      fontWeight: 'bold',
      color: ''
    },
  },
  cells: {
    style: {
      fontSize: '0.9rem'
    },
  },
};

export default function ContactsListModule() {

  const asset = true
  const [loading, setLoading] = useState(false);

  const [item, setItems] = useState(10); // rows per page
  const [rows, setRows] = useState(0); // total rows
  const [cntr, setCounter] = useState(1); // current page counter
  const [live, setLive] = useState(false); // live stream

  const [data, setData] = useState([]);

  useEffect( () => {
    if (asset){
      const fetchData = async() => {
        
        setRows ((await GetContactsCount()).data)
        
      }
      fetchData()
    } else {}
  },[asset]);

  useEffect( () => {
    if (asset){
      const fetchData = async() => {
        
        setLoading(true);
        
        setData ((await GetContactsList(({
          data: {item: item, cntr: cntr},
          user: asset.usid
        }))).data)
        
        setLoading(false);
      }
      fetchData()
    } else {}
  },[asset, cntr, item]);


  const handleItem = items => {
    setItems(items)
  }


  const handleCounter = counter => {
    setCounter(counter)
  }


  if (loading){ return ( <> <div className="text-center"><WebbSpinner /></div> </> ) }
  if (!data || data.length === 0) { return ( <> <ListNoData/> </> ) }

  return (
  <>
    {console.log(data)}
    <div className="">

      <div className="rounded-wd">
        <DataTable
          noHeader
          highlightOnHover
          title=""
          columns={columns}
          data={data}
          pagination
          paginationServer
          paginationTotalRows={rows}
          onChangeRowsPerPage={handleItem}
          onChangePage={handleCounter}
          customStyles={customStyles}
        />
      </div>

    </div>

  </>
  )
}